import { render } from "./AdminPortal.vue?vue&type=template&id=fcf808a4&ts=true"
import script from "./AdminPortal.ts?vue&type=script&lang=ts&external"
export * from "./AdminPortal.ts?vue&type=script&lang=ts&external"

import "./polteq.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__